import { NavLink, useLocation } from 'react-router-dom'

/**
 * Fixed bottom navigation for small viewports (public marketing pages).
 * Keeps primary destinations in the thumb-friendly lower screen area.
 * Hidden on dashboard, guest deposit links, and full-page auth/onboarding flows.
 */
function MobileBottomNav({ accountPath, isAuthed }) {
  const { pathname } = useLocation()

  const hidden =
    pathname.startsWith('/deposit') ||
    ['/login', '/reset-password', '/get-started', '/onboarding', '/waitlist'].includes(pathname)

  if (hidden) return null

  const linkClass = ({ isActive }) =>
    `mobile-bottom-nav__link${isActive ? ' mobile-bottom-nav__link--active' : ''}`

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary">
      <NavLink className={linkClass} to="/" end>
        <span className="mobile-bottom-nav__icon" aria-hidden>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12l9-8 9 8" />
            <path d="M5 10v10h14V10" />
          </svg>
        </span>
        <span className="mobile-bottom-nav__label">Home</span>
      </NavLink>
      <NavLink className={linkClass} to="/pricing">
        <span className="mobile-bottom-nav__icon" aria-hidden>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        </span>
        <span className="mobile-bottom-nav__label">Pricing</span>
      </NavLink>
      <NavLink className={linkClass} to="/support">
        <span className="mobile-bottom-nav__icon" aria-hidden>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </span>
        <span className="mobile-bottom-nav__label">Support</span>
      </NavLink>
      <NavLink className={linkClass} to={accountPath}>
        <span className="mobile-bottom-nav__icon" aria-hidden>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </span>
        <span className="mobile-bottom-nav__label">{isAuthed ? 'Dashboard' : 'Account'}</span>
      </NavLink>
    </nav>
  )
}

export default MobileBottomNav
